// extracted by mini-css-extract-plugin
module.exports = {"font14":"SliderEmployeeInfo_font14__wz4eK","scrl":"SliderEmployeeInfo_scrl__1TH3t"};